<template>
  <div class="app-container-page" :class="{'pc-wrapper': !mobileDevice}">
    <div class="navbar" :style="{ 'padding-top': paddingTop + 'px'}" :class="{ios:isIOS}"
         v-if="[PAGE_STATUS.NO_PRODUCTS,PAGE_STATUS.NORMAL,PAGE_STATUS.IFRAME,PAGE_STATUS.OLD_VERSION].includes(pageStatus) && !outOpen">
      <div class="navbar-back" @click="closeWebview"></div>
      <div class="navbar-title">充值默往币</div>
      <div class="navbar-menu"></div>
    </div>
    <template v-if="pageStatus === PAGE_STATUS.NO_PRODUCTS">
      <div class="empty-amount" :style="{'padding-top': `calc(1.33333rem + ${paddingTop}px )`}" v-if="!outOpen"
           :class="{ios:isIOS}">余额：
        <coin :num="formatAmount(amount)"></coin>
      </div>
      <div class="default-container">
        <img src="../../assets/image/recharge/empty.svg" alt="">
        暂未上架充值商品
      </div>
    </template>
    <template v-else-if="pageStatus === PAGE_STATUS.OLD_VERSION">
      <div class="default-container">
        <img src="../../assets/image/recharge/logo.svg" alt="" style="margin-bottom: 30px">
        {{ pageStatus === PAGE_STATUS.NOT_IN_APP ? '仅支持在默往APP内打开' : '旧版本暂不支持该功能，请升级到最新版本' }}
      </div>
    </template>
    <template v-else-if="pageStatus === PAGE_STATUS.NOT_IN_APP || pageStatus === PAGE_STATUS.NORMAL">
      <div class="coin-list"
           :style="{'padding-top': `calc(${outOpen ? '.33333rem' : '1.33333rem'} + ${paddingTop}px )`}"
           :class="{ios:isIOS}">
        <div class="amount" v-if="!outOpen">余额：
          <coin :num="formatAmount(amount)"></coin>
        </div>
        <div class="account-container" v-if="outOpen">
          <img src="../../assets/image/recharge/logo-text.png" alt="" v-if="!mobileDevice">
          <input class="account-input" type="text" v-model="account" placeholder="请输入要充值的默往ID或手机号"
                 @blur="checkAccountBlur">
          <div class="tip">{{ accountDisplay }}</div>
        </div>
        <ul class="list">
          <li v-for="item of goodsList" :class="{active: item.id === selectItem.id}" @click="selectGoods(item)">
            <div class="tag" v-if="item.activity_desc">{{ item.activity_desc }}</div>
            <coin class="coin-com" :num="item.coin"></coin>
            <span class="extra-coin" v-if="item.give_coin">+{{ item.give_coin }}默往币</span>
            <div class="buy-amount"><span class="unit">￥</span>{{ formatAmount(item.money, true) }}</div>
          </li>
        </ul>
      </div>
      <div class="bottom-pay-panel" :class="{pc: !mobileDevice}">
        <div class="title">
          <img src="../../assets/image/recharge/alipay.svg" alt="">
          <span>支付宝支付</span></div>
        <!--        <ul class="pay-list">-->
        <!--          <li v-for="item of payList" :class="{active: item.type === payType}" @click="payType = item.type"-->
        <!--              v-show="(item.type === 'wechat' && wx) || (item.type === 'alipay' && ali)">-->
        <!--            <i :style="{backgroundImage:`url('${item.icon}')`}"></i>-->
        <!--            {{ item.name }}-->
        <!--          </li>-->
        <!--        </ul>-->
        <div v-if="youngMode" class="pay-button-wrap">
          <div class="pay-button disabled">青少年模式下不支持购买</div>
        </div>
        <div v-else class="pay-button-wrap">
          <div class="pay-button" :class="{disabled: !selectItem.id || !payType}" @click="createOrder(false)"
               v-if="mobileDevice">
            立即支付{{ selectItem.id ? `￥${formatAmount(selectItem.money, true)}` : '' }}
          </div>
          <div class="pay-button" :class="{disabled: !selectItem.id || !payType}" @click="createOrder(true)">
            扫码支付{{ selectItem.id ? `￥${formatAmount(selectItem.money, true)}` : '' }}
          </div>
        </div>
        <div class="agreement">点击支付即表示同意<span @click="goAgreement">《默往币充值协议》</span></div>
      </div>
    </template>
    <template v-else-if="pageStatus === PAGE_STATUS.IFRAME">
      <div class="iframe-blank"></div>
      <iframe id="myIframe" :src="iframeSrc" :style="{'padding-top': `calc(${paddingTop}px )`}"
              :class="{ios:isIOS}"></iframe>
    </template>
    <van-overlay :show="showToast" :z-index="99">
      <div class="toast-dialog">
        <div class="tip">{{ toastTip }}</div>
        <div class="confirm" @click="showToast = false">确定</div>
      </div>
    </van-overlay>

    <van-overlay :show="paymentDialog" :z-index="9">
      <div class="payment-dialog">
        <div class="dialog-card">
          <div class="dialog-header">
            <div class="dialog-title">支付宝扫码支付</div>
            <div class="dialog-close" @click="closePaymentDialog">×</div>
          </div>
          <div class="dialog-amount">¥{{ selectItem.id ? formatAmount(selectItem.money, true) : '' }}</div>
          <div class="dialog-qrcode">
            <img :src="paymentQrcode" alt="">
            <!--            <iframe-->
            <!--              class="qr-iframe"-->
            <!--              :src="paymentQrcode"-->
            <!--              title="支付二维码"-->
            <!--              sandbox="allow-scripts allow-same-origin"-->
            <!--            ></iframe>-->
          </div>
          <div class="dialog-expire">请在{{ formattedExpire }}内支付</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Coin from './Coin.vue'
import NativeBridge from '@/utils/NativeBridge'
import rechargeApi from '@/api/recharge'
import { Toast } from 'vant'
import CryptoJS from 'crypto-js'
import qrcodeLib from 'qrcode'

// 页面状态常量
const PAGE_STATUS = {
  INIT: 0,
  NO_PRODUCTS: 1, // 未上架
  NOT_IN_APP: 2, // 未在app内部
  NORMAL: 3, // 正常状态
  IFRAME: 4, // iframe页面
  OLD_VERSION: 5 // 旧版本
}

export default {
  name: 'Recharge',
  components: { Coin },
  data () {
    return {
      account: '',
      iframeSrc: '',
      pageStatus: 0,
      PAGE_STATUS, // 将常量暴露到组件实例
      showToast: false,
      amount: 0,
      goodsList: [],
      payList: [
        {
          type: 'wechat',
          name: '微信支付',
          icon: require('../../assets/image/recharge/wechat.svg')
        },
        {
          type: 'alipay',
          name: '支付宝支付',
          icon: require('../../assets/image/recharge/alipay.svg')
        }
      ],
      payType: '',
      paddingTop: window.$paddingTop || 0,
      isIOS: !!window.webkit,
      nativeBridge: new NativeBridge(),
      selectItem: {},
      orderNo: '',
      toastTip: '',
      timer: null,
      wx: true,
      ali: true,
      youngMode: 0,
      pageShow: false,
      payToast: false,
      outOpen: false,
      mobileDevice: false,
      QRCode: false,
      paymentDialog: false,
      paymentQrcode: '',
      expireTime: 0,
      expireTimer: null,
      remainingSeconds: 0,
      queryTimer: null,
      queryOrderAbortController: null,
      accountExist: false,
      accountDisplay: ''
    }
  },
  computed: {
    formattedExpire () {
      const s = Number(this.remainingSeconds) || 0
      const hh = Math.floor(s / 3600)
      const mm = Math.floor((s % 3600) / 60)
      const ss = s % 60
      const pad = (n) => String(n).padStart(2, '0')
      return `${pad(hh)}:${pad(mm)}:${pad(ss)}`
    }
  },
  watch: {
    pageStatus (val) {
      if (val === PAGE_STATUS.IFRAME) {
        this.$nextTick(() => {
          const iframe = document.getElementById('myIframe')
          let lastUrl = iframe.src
          this.timer = setInterval(function () {
            try {
              const currentUrl = iframe.contentWindow.location.href
              if (currentUrl !== lastUrl && currentUrl !== 'about:blank') {
                window.location.replace(currentUrl)
              }
            } catch (e) {
              console.log('无法直接访问跨域 iframe')
            }
          }, 500)
        })
      } else {
        this.timer && clearInterval(this.timer)
      }
    }
  },
  created () {
    // 检测是否为移动端设备，移动端为 true，PC 为 false
    try {
      const ua = window.navigator.userAgent || ''
      this.mobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
    } catch (e) {
      this.mobileDevice = false
    }

    // const ua = window.navigator.userAgent
    // if (!ua.toLowerCase().includes('mostone')) {
    //   this.pageStatus = 2
    //   return
    // }
    // this.pageHiddenOrShow()
    if (window.$userToken) {
      this.getDataList()
      const orderNo = this.$route.query.out_trade_no
      if (orderNo) this.queryOrder(orderNo)
    }
    window.onload = () => {
      if (!window.webkit) {
        this.nativeBridge.sendMessage('getStatusNavBarToApp').then(res => {
          if (res.code === 200) {
            this.paddingTop = res.data.statusBar / window.devicePixelRatio
            window.$paddingTop = this.paddingTop
          }
        })
        this.nativeBridge.sendMessage('hasOpenYoungMode').then(res => {
          if (res.code === 200) {
            this.youngMode = res.data
          }
        })
      }
      window.$key = 'thisis32bitlongpassphraseixiamen'
      this.nativeBridge.sendMessage('getUserTokenToApp').then(res => {
        if (res.code === 200) {
          window.$userToken = res.data.token
          this.nativeBridge.sendMessage('getInterfaceKeyToApp').then(res => {
            if (res.code === 200) {
              window.$key = res.data.key
              window.$innerVersionCode = res.data.innerVersionCode
              this.getDataList()
              const orderNo = this.$route.query.out_trade_no
              if (orderNo) this.queryOrder(orderNo)
            }
          }).catch(e => {
            this.pageStatus = PAGE_STATUS.OLD_VERSION
          })
        }
      }).catch(err => {
        this.pageStatus = PAGE_STATUS.NOT_IN_APP
        this.outOpen = true
        this.getOpenDataList()
      })
    }
  },
  methods: {
    selectGoods (item) {
      this.selectItem = item
    },
    getDataList () {
      rechargeApi.rechargeGoods().then(res => {
        res = JSON.parse(this.decryptGoAESSimple(res, window.$key))
        if (res.code === 200) {
          this.amount = res.data.user_coin
          this.goodsList = res.data.products || []
          this.pageStatus = this.goodsList.length > 0 ? PAGE_STATUS.NORMAL : PAGE_STATUS.NO_PRODUCTS
          if (this.goodsList.length > 0) this.selectItem = this.goodsList[0]
          this.wx = res.data.wx === 1
          this.ali = res.data.ali === 1
          if (this.wx) this.payType = 'wechat'
          else if (this.ali && !this.wx) this.payType = 'alipay'
          else this.payType = ''
        } else {
          Toast(res.msg)
        }
      })
    },
    getOpenDataList () {
      rechargeApi.rechargeOpenGoods().then(res => {
        res = JSON.parse(this.decryptGoAESSimple(res, window.$key))
        if (res.code === 200) {
          this.amount = res.data.user_coin
          this.goodsList = res.data.products || []
          this.pageStatus = this.goodsList.length > 0 ? PAGE_STATUS.NORMAL : PAGE_STATUS.NO_PRODUCTS
          if (this.goodsList.length > 0) this.selectItem = this.goodsList[0]
          this.wx = res.data.wx === 1
          this.ali = res.data.ali === 1
          if (this.wx) this.payType = 'wechat'
          else if (this.ali && !this.wx) this.payType = 'alipay'
          else this.payType = ''
        } else {
          Toast(res.msg)
        }
      })
    },
    createOrder (qrcode) {
      if (!this.selectItem.id || !this.payType) return
      this.QRCode = qrcode
      let params = JSON.stringify({
        'account': this.account,
        'payment_object': 'coin_recharge',
        'product_id': this.selectItem.id,
        'pay_method': this.payType,
        'pay_type': this.QRCode ? 'qrcode' : 'wap',
        'return_url': window.location.origin + window.location.pathname + '?screen=full',
        'expand_param': this.selectItem
      })
      let methods = this.QRCode ? 'createQrcodeOrder' : 'createOrder'
      if (this.outOpen) methods = 'createOpenOrder'
      params = this.encryptGoAES(params, window.$key)
      rechargeApi[methods](params).then(res => {
        res = JSON.parse(this.decryptGoAESSimple(res, window.$key))
        if (res.code === 200) {
          this.orderNo = res.data.order_no
          if (this.QRCode) {
            this.paymentDialog = true
            // 使用 qrcode 库将后端返回的 qrcode_url 或 payment_html 生成二维码图片（data URL）
            const qrSource = res.data.qrcode_url || res.data.pay_url || ''
            // 清理旧的定时器与轮询请求
            this.stopExpireCountdown()
            qrcodeLib.toDataURL(qrSource, { margin: 1, width: 300, padding: 10 })
              .then(dataUrl => {
                this.paymentQrcode = dataUrl
                this.expireTime = res.data.expire_time
                this.startExpireCountdown(this.expireTime)
                // startExpireCountdown 内会清空定时器，故在此之后创建 controller 并启动轮询
                this.queryOrderAbortController = new AbortController()
                const pollSignal = this.queryOrderAbortController.signal
                this.queryTimer = setInterval(() => {
                  this.queryOrder(this.orderNo, { signal: pollSignal, isPolling: true })
                }, 1000)
              })
              .catch(err => {
                console.error('生成二维码失败，回退使用原始链接或 HTML：', err)
                this.paymentQrcode = qrSource
                this.expireTime = res.data.expire_time
                this.startExpireCountdown(this.expireTime)
                this.queryOrderAbortController = new AbortController()
                const pollSignal = this.queryOrderAbortController.signal
                this.queryTimer = setInterval(() => {
                  this.queryOrder(this.orderNo, { signal: pollSignal, isPolling: true })
                }, 1000)
              })
          } else {
            if (this.outOpen) {
              window.location.href = res.data.pay_url
            } else {
              this.iframeSrc = res.data.pay_url
              this.pageStatus = PAGE_STATUS.IFRAME
            }
          }
        } else if (res.code === 602 || res.code === 606) {
          Toast(res.msg)
          this.outOpen ? this.getOpenDataList() : this.getDataList()
          this.selectItem = {}
        } else if (res.code === 609) {
          this.toastTip = res.msg
          this.showToast = true
        } else {
          Toast(res.msg)
        }
      })
    },
    queryOrder (orderNo, options = {}) {
      let params = JSON.stringify({ order_no: orderNo })
      let methods = !this.outOpen ? 'queryOrder' : 'queryOpenOrder'
      const config = {
        ...(options.signal && { signal: options.signal }),
        ...(options.isPolling && { skipToastOnStatus0: true })
      }
      rechargeApi[methods](this.encryptGoAES(params, window.$key), config)
        .then(res => {
          res = JSON.parse(this.decryptGoAESSimple(res, window.$key))
          if (res.code === 200) {
            const status = res.data.status
            if (status !== 'PENDING') {
              this.paymentDialog = false
              this.stopExpireCountdown()
              this.outOpen ? this.getOpenDataList() : this.getDataList()
            }
            if (status === 'NOTPAY') {
              Toast('您已取消支付')
            } else if (status === 'SUCCESS') {
              this.toastTip = '支付成功'
              this.showToast = true
            } else if (status === 'CLOSED') {
              this.toastTip = '订单超时关闭，请重新下单'
              this.showToast = true
            } else if (status === 'FAIL') {
              this.toastTip = '订单支付失败，请重新下单'
              this.showToast = true
            } else if (status !== 'PENDING') {
              this.outOpen ? this.getOpenDataList() : this.getDataList()
              Toast(res.msg)
            }
          } else {
            this.paymentDialog = false
            this.stopExpireCountdown()
            this.outOpen ? this.getOpenDataList() : this.getDataList()
            Toast(res.msg)
          }
        })
        .catch(err => {
          // 主动取消：不处理
          if (err.code === 'ERR_CANCELED' || err.name === 'CanceledError') return
          // iOS WebView 常导致轮询请求 status 0 / 网络错误，静默忽略，下一轮会重试
          const isStatus0 = err.request.status === 0
          const isNetworkError = err.code === 'ERR_NETWORK' || err.message === 'Network Error'
          if (isStatus0 || isNetworkError) return
          this.paymentDialog = false
          this.stopExpireCountdown()
          this.outOpen ? this.getOpenDataList() : this.getDataList()
          Toast(err.message || '查询订单失败')
        })
    },
    // 账号失去焦点时校验账号是否存在（调用后端接口 /h5/recharge/open/account/check）
    checkAccountBlur () {
      const accountVal = (this.account || '').trim()
      if (!accountVal) {
        this.accountExist = false
        this.accountDisplay = ''
        return
      }
      const params = JSON.stringify({ account: accountVal })
      rechargeApi.checkAccount(this.encryptGoAES(params, window.$key)).then(res => {
        try {
          res = JSON.parse(this.decryptGoAESSimple(res, window.$key))
        } catch (e) {
          console.error('解析 checkAccount 返回失败', e)
          Toast('校验失败')
          return
        }
        if (res.code === 200) {
          const data = res.data || {}
          if (data.exist) {
            this.accountExist = true
            const nick = data.nickname || ''
            const uid = data.user_id || ''
            this.accountDisplay = `${nick}`
          } else {
            this.accountExist = false
            this.accountDisplay = '账号不存在'
          }
        } else {
          this.accountExist = false
          this.accountDisplay = '账号不存在'
        }
      }).catch(err => {
        console.error('checkAccount 请求失败', err)
        Toast('校验失败')
      })
    },
    closeWebview (e) {
      if (this.pageStatus === PAGE_STATUS.IFRAME) {
        this.pageStatus = PAGE_STATUS.NORMAL
        // this.queryOrder(this.orderNo)
      } else {
        this.nativeBridge.sendMessage('quitWebView')
      }
    },
    goAgreement () {
      if (this.outOpen) {
        window.location.href = '/mwrecharge'
      } else {
        if (this.isIOS) {
          this.$router.replace('/coin/recharge/agreement')
        } else {
          this.$router.push('/coin/recharge/agreement')
        }
      }
    },
    pageHiddenOrShow () {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.pageShow = true
          console.log('show page ===>' + this.payToast)
          if (!this.payToast) {
            const orderNo = this.$route.query.out_trade_no
            if (orderNo) this.queryOrder(orderNo)
          }
        } else if (document.visibilityState === 'hidden') {
          this.pageShow = false
        }
      })
    },
    // 启动倒计时（后端返回为秒级到期时间戳，使用毫秒差计算以避免四舍五入导致的 +1 秒）
    startExpireCountdown (expireSecondsTimestamp) {
      this.stopExpireCountdown()
      const v = Number(expireSecondsTimestamp) || 0
      if (v <= 0) return
      const remainingMs = expireSecondsTimestamp
      let remaining = Math.ceil(remainingMs)
      if (remaining <= 0) {
        this.remainingSeconds = 0
        this.paymentDialog = false
        return
      }
      this.remainingSeconds = remaining
      this.expireTimer = setInterval(() => {
        if (this.remainingSeconds <= 0) {
          this.stopExpireCountdown()
          this.paymentDialog = false
          return
        }
        this.remainingSeconds--
      }, 1000)
    },
    stopExpireCountdown () {
      if (this.queryTimer) {
        clearInterval(this.queryTimer)
        this.queryTimer = null
      }
      if (this.queryOrderAbortController) {
        this.queryOrderAbortController.abort()
        this.queryOrderAbortController = null
      }
      if (this.expireTimer) {
        clearInterval(this.expireTimer)
        this.expireTimer = null
      }
    },
    closePaymentDialog () {
      this.paymentDialog = false
      this.stopExpireCountdown()
    },
    encryptGoAES (plaintext, key) {
      try {
        // 1. 生成随机 IV（16 字节）
        const iv = CryptoJS.lib.WordArray.random(16)

        // 2. 将密钥转换为 WordArray
        const keyBytes = CryptoJS.enc.Utf8.parse(key)

        // 3. 将明文转换为 WordArray
        const plaintextBytes = CryptoJS.enc.Utf8.parse(plaintext)

        // 4. 执行 AES-CBC 加密
        const encrypted = CryptoJS.AES.encrypt(
          plaintextBytes,
          keyBytes,
          {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          }
        )

        // 5. 组合 IV 和密文（IV 在前，密文在后）
        // 注意：Go 的格式是 IV(16字节) + 加密数据
        const ivWithCiphertext = CryptoJS.lib.WordArray.create()
          .concat(iv) // 添加 IV
          .concat(encrypted.ciphertext) // 添加密文

        // 6. 转换为 Base64
        return CryptoJS.enc.Base64.stringify(ivWithCiphertext)
      } catch (error) {
        console.error('加密失败:', error)
        throw error
      }
    },
    decryptGoAESSimple (ciphertextBase64, key) {
      try {
        // 解析完整的密文（包含IV）
        const encryptedData = CryptoJS.enc.Base64.parse(ciphertextBase64)

        // 提取IV（前16字节）
        const ivHex = CryptoJS.enc.Hex.stringify(
          CryptoJS.lib.WordArray.create(encryptedData.words.slice(0, 4))
        )
        const iv = CryptoJS.enc.Hex.parse(ivHex)

        // 提取密文部分
        const ciphertextHex = CryptoJS.enc.Hex.stringify(
          CryptoJS.lib.WordArray.create(encryptedData.words.slice(4))
        )
        const ciphertext = CryptoJS.enc.Hex.parse(ciphertextHex)

        // 密钥
        const keyBytes = CryptoJS.enc.Utf8.parse(key)

        // 解密
        const decrypted = CryptoJS.AES.decrypt(
          { ciphertext: ciphertext },
          keyBytes,
          {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          }
        )

        return decrypted.toString(CryptoJS.enc.Utf8)
      } catch (error) {
        console.error('解密失败:', error)
        throw error
      }
    },
    formatAmount (amount, divideBy100 = false) {
      // 转为字符串并移除可能的逗号
      let str = String(amount).replace(/,/g, '')

      // 处理负数
      const isNegative = str.startsWith('-')
      if (isNegative) {
        str = str.substring(1)
      }

      // 如果需要除以100
      if (divideBy100) {
        // 确保长度至少为2
        if (str.length < 2) {
          str = '0'.repeat(2 - str.length) + str
        }

        // 分割整数和小数部分
        const integerPart = str.substring(0, str.length - 2) || '0'
        const decimalPart = str.substring(str.length - 2)

        // 组合成结果
        str = integerPart + (decimalPart !== '00' ? '.' + decimalPart.replace(/0+$/, '') : '')
      }

      // 千分位格式化
      const parts = str.split('.')
      let integerPart = parts[0]
      const decimalPart = parts[1] ? '.' + parts[1] : ''

      // 对整数部分进行千分位格式化
      const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

      // 返回结果，处理负数
      return (isNegative ? '-' : '') + formattedInteger + decimalPart
    }
  }
}
</script>
<style>
@media screen and (min-width: 480px) {
  html, body {
    font-size: 46px;
  }
}
</style>
<style scoped lang="scss">
@import "@/assets/css/style.scss";

.app-container-page {
  font-size: px2rem(32);
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  user-select: none;
  margin: 0 auto;

  &.pc-wrapper {
    padding: 0 10%;
    width: 80%;

    .dialog-qrcode .qr-iframe {
      width: 160px !important;
      height: 160px !important;
    }

    .account-container {
      width: 380px;
    }

    .coin-list {
      padding-bottom: 0;
      min-height: auto;
    }

    .pc {
      width: 400px;

      .pay-list {
        display: block;

        li {
          width: 166px !important;
          height: 50px;
          font-size: 16px;
        }
      }

      .pay-button-wrap {
        display: block;

        .pay-button {
          width: 166px !important;
          height: 50px;
          font-size: 16px;
          cursor: pointer;

          &:hover {
            filter: brightness(90%);
          }
        }
      }

      .agreement {
        text-align: left;
      }
    }

  }

  .navbar {
    width: 100%;
    height: px2rem(100);
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #000;
    font-size: px2rem(32);
    position: fixed;
    top: 0;
    z-index: 9;
    background: #fff;
    font-weight: bold;

    &.ios {
      //padding-top: 44px!important;
      padding-top: constant(safe-area-inset-top, 44px) !important;
      padding-top: env(safe-area-inset-top, 44px) !important;
    }

    .navbar-back {
      width: px2rem(100);
      height: px2rem(100);
      background-image: url("../../assets/image/invite/back_black.svg");
      background-repeat: no-repeat;
      background-position: center;
    }

    .navbar-menu {
      width: px2rem(100);
      height: px2rem(100);
      display: flex;
      align-items: center;
      font-size: px2rem(30);
    }
  }

  .iframe-blank {
    width: 100%;
    height: px2rem(100);
    position: relative;
    z-index: 2;
    background: #fff;

  }

  #myIframe {
    position: relative;
    z-index: 1;
    top: px2rem(-100);
    width: 100%;
    min-height: 100%;
    padding-bottom: px2rem(450);
    box-sizing: border-box;
    border: 0;
    outline: none;

    &.ios {
      padding-top: calc(constant(safe-area-inset-top)) !important;
      padding-top: calc(env(safe-area-inset-top)) !important;
    }
  }

  .account-container {
    padding: 0 px2rem(32);

    img {
      width: px2rem(242);
      margin-bottom: px2rem(40);
    }

    .account-input {
      padding: 0 px2rem(20);
      border: 1px solid #EEEEEF;
      width: 100%;
      display: flex;
      height: px2rem(96);
      box-sizing: border-box;
      box-shadow: 0px 5px 20px 0px #0000000D;
      border-radius: px2rem(10);
    }

    .tip {
      color: #FB5858;
      font-size: px2rem(28);
      padding: px2rem(5) px2rem(10);
    }
  }

  .coin-list {
    width: 100%;
    min-height: 100%;
    padding-bottom: px2rem(450);
    box-sizing: border-box;

    &.ios {
      padding-top: calc(1.33333rem + constant(safe-area-inset-top)) !important;
      padding-top: calc(1.33333rem + env(safe-area-inset-top)) !important;
    }

    .amount {
      @include center();
      font-weight: bold;
    }

    .list {
      display: flex;
      flex-wrap: wrap;
      padding: px2rem(20) px2rem(7);

      li {
        width: px2rem(320);
        height: px2rem(192);
        border: px2rem(1) solid #eeeeef;
        box-shadow: 0px 5px 20px 0px #0000000D;
        border-radius: px2rem(10);
        margin: px2rem(16) px2rem(22);
        position: relative;
        @include centerV();
        line-height: 1;

        :deep(.coin-amount) {

          strong {
            font-size: px2rem(48);
          }
        }

        .coin-com {
          margin-bottom: px2rem(10);
        }

        .extra-coin {
          color: #FF873D;
          font-size: px2rem(24);
          font-weight: bold;
        }

        .buy-amount {
          font-weight: bold;
          margin-top: px2rem(10);
        }

        .tag {
          position: absolute;
          top: 0;
          right: 0;
          background-color: #FF873D;
          color: #fff;
          padding: px2rem(2) px2rem(10) 0 px2rem(10);
          font-size: px2rem(22);
          border-top-right-radius: px2rem(10);
          border-bottom-left-radius: px2rem(10);
          box-sizing: border-box;
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 0;
          height: px2rem(32);
          @include centerV();
        }

        &.active {
          border-color: #FF873D;
          background-color: #FEE9D4;
        }
      }
    }
  }

  .bottom-pay-panel {
    border: px2rem(1) solid #eeeeef;
    width: 100%;
    height: px2rem(450);
    box-sizing: border-box;
    background: #fff;
    border-top-right-radius: px2rem(32);
    border-top-left-radius: px2rem(32);
    position: fixed;
    bottom: 0;
    padding: px2rem(32);

    &.pc {
      position: relative;
      border: 0;

      .title {
        justify-content: flex-start;
      }
    }

    .title {
      font-size: px2rem(28);
      font-weight: bold;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        margin: 0 4px;
        font-weight: normal;
      }
    }

    .pay-list {
      display: flex;
      padding: px2rem(32) 0;

      li {
        height: px2rem(96);
        flex: 1;
        @include center();
        border: 1px solid #eeeeef;
        border-radius: px2rem(10);
        box-sizing: border-box;
        margin-right: px2rem(48);
        line-height: 1;
        font-size: px2rem(28);

        &:last-child {
          margin-right: 0;
        }

        i {
          width: px2rem(44);
          height: px2rem(44);
          background-size: 100% 100%;
          margin-right: px2rem(5);
        }

        &.active {
          border-color: #E7D4A7;
          background-color: #FAF6ED;
        }
      }
    }

    .pay-button-wrap {
      //display: flex;
      //flex-direction: column!important;
      //gap: px2rem(24);
      margin-top: 16px;

      .pay-button {
        flex: 1;
        height: px2rem(100);
        border-radius: px2rem(10);
        background: #FF873D;
        @include centerV();
        color: #fff;
        margin-bottom: 16px;
        //flex-shrink: 0;
        &.disabled {
          background: #f8d0b7;
        }
      }
    }

    .agreement {
      text-align: center;
      font-size: px2rem(24);
      margin-top: px2rem(16);
      color: #B6B7BA;

      span {
        color: #FAAD01;
      }
    }
  }

  .default-container {
    width: 100%;
    height: 100%;
    @include centerV();
    font-size: px2rem(28);
    color: #B6B7BA;
  }

  .empty-amount {
    width: 100%;
    position: fixed;
    @include center();
    font-weight: bold;

    &.ios {
      padding-top: calc(1.33333rem + constant(safe-area-inset-top)) !important;
      padding-top: calc(1.33333rem + env(safe-area-inset-top)) !important;
    }
  }

  .toast-dialog {
    width: px2rem(480);
    height: px2rem(320);
    background: #fff;
    border-radius: px2rem(32);
    overflow: hidden;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .tip {
      height: px2rem(222);
      padding: 0 px2rem(32);
      box-sizing: border-box;
      @include centerV();
      text-align: center;
    }

    .confirm {
      width: 100%;
      height: px2rem(100);
      background: #FF873D;
      @include center();
      color: #fff;
    }
  }

  .payment-dialog {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    @include center();

    .dialog-card {
      width: px2rem(680);
      background: #fff;
      border-radius: px2rem(24);
      padding: px2rem(32);
      box-sizing: border-box;
      position: relative;
      @include centerV();
      flex-direction: column;
      text-align: center;

      .dialog-header {
        width: 100%;
        position: relative;

        .dialog-title {
          font-size: px2rem(32);
          font-weight: bold;
        }

        .dialog-close {
          position: absolute;
          top: px2rem(-8);
          right: px2rem(-8);
          width: px2rem(64);
          height: px2rem(64);
          @include center();
          cursor: pointer;
          font-size: px2rem(48);
          line-height: 1;
        }
      }

      .dialog-amount {
        margin-top: px2rem(8);
        font-size: px2rem(40);
        font-weight: bold;
      }

      .dialog-qrcode {
        margin-top: px2rem(18);

        img {
          width: 300px;
        }

        .qrcode-iframe {
          width: px2rem(310);
          border: none;
          object-fit: contain;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .dialog-expire {
        margin-top: px2rem(12);
        color: #B6B7BA;
        font-size: px2rem(24);
      }
    }
  }
}

</style>

<style>
html, body, #app {
  overscroll-behavior: none;
  -webkit-overflow-scrolling: auto;
}
</style>
